export function joinUrl(...parts: string[]): string {
  return parts.map(part => {
    // Trim leading and trailing slashes
    return part.replace(/^\/+|\/+$/g, '');
  }).join('/');
}

export function parseBooleanParam(value: string | null): boolean | undefined {
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  return undefined;
}
